"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getCookie = _interopRequireDefault(require("./getCookie"));
var _constants = _interopRequireDefault(require("./constants"));
var getCredentialsSync = function getCredentialsSync() {
  var signInModeCookieResponse = (0, _getCookie["default"])('signInMode');
  if (!signInModeCookieResponse.cookieExists) return '';
  switch (signInModeCookieResponse.cookieValue) {
    case _constants["default"].cognito:
      var cognitoIdTokenCookieResponse = (0, _getCookie["default"])('cognitoIdToken');
      if (cognitoIdTokenCookieResponse.cookieExists) return cognitoIdTokenCookieResponse.cookieValue;
      return '';
    case _constants["default"].microsoft:
      var microsoftIdTokenCookieResponse = (0, _getCookie["default"])('microsoftIdToken');
      if (microsoftIdTokenCookieResponse.cookieExists) return microsoftIdTokenCookieResponse.cookieValue;
      return '';
    case _constants["default"].google:
      var googleIdTokenCookieResponse = (0, _getCookie["default"])('googleIdToken');
      if (googleIdTokenCookieResponse.cookieExists) return googleIdTokenCookieResponse.cookieValue;
      return '';
    default:
      return '';
  }
};
var _default = exports["default"] = getCredentialsSync;